module.exports = __webpack_public_path__ + "images/0588f9997531f67153b6888d9e086484.svg";